import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { Observable, map } from 'rxjs';
import { FeatureToggleService } from './feature-toggle.service';

/**
 * Route guard for the single check point at a feature's entry. Add to the
 * route declaration alongside AuthGuard, and put the toggle key in
 * `data.featureToggle`. If the toggle is off the user is redirected to /error 404
 * so the feature looks invisible rather than forbidden.
 */
@Injectable({ providedIn: 'root' })
export class FeatureToggleGuard implements CanActivate {
  private readonly service = inject(FeatureToggleService);
  private readonly router = inject(Router);

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    const key = route.data['featureToggle'] as string | undefined;

    return this.service.loadActive().pipe(
      map(() => {
        if (!key) {
          return true;
        }
        if (this.service.isEnabled(key)) {
          return true;
        }
        this.router.navigate(['/error'], { queryParams: { code: 404 } });
        return false;
      }),
    );
  }
}
